export enum ProductTypeEnum {
  ORV = 'ORV',
  MLB = 'MLB',
  GG = 'GG',
  NB = 'NB',
  EOP = 'EOP',
  BG = 'BG',
  TIB = 'TIB',
  AP = 'AP',
  UNKNOWN = 'UNKNOWN',
}
